export default __webpack_public_path__ + "static/media/crown.b7fc8916.png";